import { z } from 'zod';
import { Pod } from './Pod';

export interface Branch {
  id: number;
  branchName: string;
  branchAbbreviation: string;
  options?: BranchOption[];
}

export const exampleBranch: Branch = {
  id: 1,
  branchName: 'Test',
  branchAbbreviation: 'TST',
};

export interface BranchOption {
  id: number;
  branchID: number;
  name: string;
}

export interface BranchWithPods extends Branch {
  pods: Pod[];
}

export const UpdateBranchDTO = z.object({
  branch: z.object({
    branch_name: z.string(),
    abbreviation: z.string().max(3),
  }),
  options: z.array(
    z.object({
      id: z.number().optional(),
      name: z.string(),
    }),
  ),
});

export type UpdateBranch = z.infer<typeof UpdateBranchDTO>;

export interface PaginatedBranchResponse {
  branches: Branch[];
  page: number;
  count: number;
}
